module.exports = __webpack_public_path__ + "img/pic-qrcode-2.5b2e60ea.jpg";